import { render, staticRenderFns } from "./EducationalCourseLevels.vue?vue&type=template&id=20df209f&"
import script from "./EducationalCourseLevels.vue?vue&type=script&lang=js&"
export * from "./EducationalCourseLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports